import { Controller } from '@hotwired/stimulus';

// Fenêtre de l'intervention : le client choisi préremplit l'adresse et le
// code postal laissés vides (`addresses` : { id du client: { address, zipcode } }).
export default class extends Controller {
    static values = { addresses: Object };

    fill({ target }) {
        if (target.name !== 'technician[control_customer_id]') return;
        const customer = this.addressesValue[target.value];
        if (!customer) return;
        this.prefill('technician[control_address]', customer.address);
        this.prefill('technician[control_zipcode]', customer.zipcode);
    }

    prefill(name, value) {
        const field = this.element.elements.namedItem(name);
        if (field && field.value.trim() === '' && value) field.value = value;
    }
}
